import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardExpandToggler,
} from "../../../components/card/card.jsx";

import TopCards from "../components/top-cards";
import LocationCards from "../components/location-cards";
import { dashboard, machineProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import {
    formatDateOnly,
  generateLocationToArray,
  machineHealthColor,
} from "../../../utils/helper";
import { useNavigate } from "react-router-dom";
import AlarmBreakdown from "../components/alarm-breakdown-chart.jsx";
import AlarmTable from "../components/alarm-table.jsx";
import { LocationFilter } from "../../../components/LocationFilter";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext";
import { AlarmTrend } from "../components/admin_overview/AlarmTrend";
import { AlarmResolutionSpeed } from "../components/admin_overview/AlarmResolutionSpeed";
import { AverageResolutionTime } from "../components/admin_overview/AverageResolutionTime";
import { MachineHealthClassification } from "../components/admin_overview/MachineHealthClassification";
import { MaintenanceCostOvertime } from "../components/admin_overview/MaintenanceCostOvertime";
import { UnplannedDowntime } from "../components/admin_overview/UnplannedDowntime";
import { ManHour } from "../components/admin_overview/ManHour";
import { MachineUptime } from "../components/admin_overview/MachineUptime";

function AdminOverview() {
  const {
    selectedLocationOverview,
    selectedMachineOverview,
    dateRangeOverview,
    updateSelectedLocationOverview,
    updateSelectedMachineOverview,
    updateDateRangeOverview,
  } = useDashboardContext();
  const navigate = useNavigate();
  const { config } = useAuth();
  const [lowestMachine, setLowestMachine] = useState([]);
  const [highestMachine, setHighestMachine] = useState([]);
  const [allLowestMachine, setAllLowestMachine] = useState([]);
  const [allMachines, setAllMachines] = useState([]);
  const [filteredMachines, setFilteredMachines] = useState([]);
  const [selectedHealth, setSelectedHealth] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [tmpStatusSelection, setTmpSelectedStatus] = useState("");
  const [tmpSelection, setTempSelection] = useState("");
  const [clickCounter, setClickCounter] = useState(0);
  const [clickStatusCounter, setClickStatusCounter] = useState(0);
  const [selectedtedLocation, setSelectedtedLocation] = useState("");
  function randomNo() {
    return Math.floor(Math.random() * 60) + 30;
  }
  const [dateRangeCurrentWeek, setDateRangeCurrentWeek] = useState(
    "- Select Date Range -"
  );

  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;

    updateDateRangeOverview({
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    });
  }

  useEffect(() => {
    const currentWeek =
      formatDateOnly(dateRangeOverview?.startDate) +
      " - " +
      formatDateOnly(dateRangeOverview?.endDate);
    setDateRangeCurrentWeek(currentWeek);
  }, [dateRangeOverview]);

  return (
    <div>
      <div className="row mb-2">
        <div className="col-4 flex-grow-1">
          <h4 className="">Admin Overview</h4>
        </div>
        <div className="col-3">
          <DateRangePicker
            startDate={dateRangeOverview?.startDate}
            endDate={dateRangeOverview?.endDate}
            onApply={handleDateApplyEvent}
          >
            <button
              className="btn btn-outline-theme text-truncate me-3 mb-2 mb-sm-0"
              style={{ width: "100%" }}
            >
              <i className="fa fa-fw fa-calendar me-1"></i>
              <span>{dateRangeCurrentWeek}</span>
              <i className="fa fa-fw fa-caret-down me-n1"></i>
            </button>
          </DateRangePicker>
        </div>
      </div>

      <hr></hr>

      <div className="row mt-4">
        <div className="col-xl-6">
          <AlarmTrend />
        </div>
        <div className="col-xl-6">
          <AlarmResolutionSpeed />
        </div>
        <div className="col-xl-6 mt-4">
          <AverageResolutionTime />
        </div>

        <div className="col-xl-6 mt-4">
          <MachineHealthClassification />
        </div>

        <div className="col-xl-12 mt-4">
          <MachineUptime />
        </div>

        <div className="col-xl-6 mt-4">
          <MaintenanceCostOvertime />
        </div>
        <div className="col-xl-6 mt-4">
          <UnplannedDowntime />
        </div>
        <div className="col-xl-6 mt-4">
          <ManHour />
        </div>

        {config?.is_matar ? (
          <div className="col-xl-6">
            <Card className="mb-3">
              <CardBody>
                <div className="d-flex fw-bold small mb-3">
                  <span className="flex-grow-1">
                    Top 5 Forcasted Asset Replacement
                  </span>
                  <CardExpandToggler />
                </div>
                <div className="table-responsive">
                  <table className="table table-striped table-borderless mb-2px small text-nowrap tr-hover">
                    <thead>
                      <tr>
                        <th>Asset</th>
                        <th>Zone</th>
                        <th>Replacement Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Air Compressor (ASD-GSE-01CR01-PAC002)</td>
                        <td>1</td>
                        <td>2028</td>
                      </tr>
                      <tr>
                        <td>Air Compressor (ASD-GSE-03CR02-PAC003)</td>
                        <td>1</td>
                        <td>2026</td>
                      </tr>
                      <tr>
                        <td>Air Compressor (LSD-MWB-01WK13-PAC004)</td>
                        <td>1</td>
                        <td>2029</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default AdminOverview;
